export function getOptionLabel(option) {
  return option
}
